exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bigbox{display:block;position:absolute;bottom:5rem;right:5rem;margin-left:5rem;width:344px;max-width:100%;height:344px;background-color:#fff;overflow:hidden;border:.3rem solid #000;margin:-.15rem}.bigbox:before{content:\"Publicit\\E9\";font-weight:700;font-family:Open Sans Condensed;font-size:2rem;text-transform:uppercase;text-align:center;width:100%;display:inline-block;margin:1.25rem auto}.bigbox>.adsbygoogle{display:block;text-align:center;height:250px;max-height:100%}@media screen and (max-width:1100px){.bigbox{position:relative;bottom:2.5rem;right:0;margin:0 auto 0 5rem}}@media screen and (max-width:614px){.bigbox{width:auto;margin:0 5rem}}@media screen and (max-width:480px){.bigbox{margin:0 3rem}}@media screen and (max-width:348px){.bigbox{width:320px;border:none;height:auto;margin:0 auto}}@media screen and (max-width:320px){.bigbox{width:300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/styles/bigbox.scss
// module id = 199
// module chunks = 0